import {Vector3} from 'three'
export default {
  mona: [
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 22},
      table: {position: new Vector3(-0.2, 0, 0), scale: 13},
      mobile: {position: new Vector3(0, 0, 0), scale: 8},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(0, 0, 0), scale: 11},
      mobile: {position: new Vector3(0, 0, 0), scale: 6},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(-0.8, 0, 0), scale: 10},
      mobile: {position: new Vector3(-3.5, 0, 0), scale: 5.5},
    },
  ],
  copilot: [
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 22},
      table: {position: new Vector3(0.6, 0, 0), scale: 13.5},
      mobile: {position: new Vector3(0.8, 0, 0), scale: 8},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(0.5, 0, 0), scale: 11.7},
      mobile: {position: new Vector3(0, 0, 0), scale: 7},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 17},
      table: {position: new Vector3(-0.8, 0, 0), scale: 10},
      mobile: {position: new Vector3(-3.5, 0, 0), scale: 5.5},
    },
  ],
  security: [
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(0, 0, 0), scale: 10},
      mobile: {position: new Vector3(0, 0, 0), scale: 6},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 22},
      table: {position: new Vector3(0, 0, 0), scale: 13},
      mobile: {position: new Vector3(0, 0, 0), scale: 8},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(0, 0, 0), scale: 11.5},
      mobile: {position: new Vector3(0, 0, 0), scale: 6},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 17},
      table: {position: new Vector3(-0.8, 0, 0), scale: 10},
      mobile: {position: new Vector3(-2.8, 0, 0), scale: 5.5},
    },
  ],
  invertocat: [
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 22},
      table: {position: new Vector3(-0.2, 0, 0), scale: 13},
      mobile: {position: new Vector3(0, 0, 0), scale: 8},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(0, 0, 0), scale: 11},
      mobile: {position: new Vector3(0, 0, 0), scale: 6},
    },
    {
      desktop: {position: new Vector3(0, 0, 0), scale: 18},
      table: {position: new Vector3(-0.8, 0, 0), scale: 10},
      mobile: {position: new Vector3(-3.5, 0, 0), scale: 5.5},
    },
  ],
}
